export default {
  borderRadius: '28px',
  borderWidth: '2px',
  borderColor: 'var(--black)',
  margin: '1rem auto',
  ctaTextColor: 'var(--dark-teal)',
  ctaButtonPadding: '.8rem 5rem',
};
